import * as axiosProvider from '../../helpers/providers/axiosProvider';
import * as errorProvider from '../../helpers/providers/errorProvider';
import * as requestTypes from '../../helpers/const/requestTypes';
import { getErrorMessage } from '../../helpers/formatters/errorFormatter';
import { startFetching, endFetching } from '../../features/dataFetching/dataFetchingSlice';
import { setError } from '../../features/error/errorSlice';
import { executePost } from '../../api/Fetch';

let refreshTokenPending = false;
let result = null;

//Middleware for api requests.
export const api = store => next => action => {
    if (action.request) {
        return processRequest(action.request, store);
    } else {
        next(action);
    }
};

//Process request.
async function processRequest(request, store) {
    store.dispatch(startFetching(request.url));
    return await processRequestByRequestType(request)
        .then((response) => {
            if(response.data.wasSuccesfull)
                store.dispatch(request.onSuccess(response.data));
            else
            {
                let errorMessage = response.data.error.message;
                store.dispatch(request.onFailure());
                store.dispatch(setError(errorMessage));
            }

        })
        .catch((error) => {
            let errorMessage = getErrorMessage(error);
            console.log(errorMessage);
            store.dispatch(request.onFailure());
            store.dispatch(setError(errorMessage));
            errorProvider.handleApiError(store, error);
            throw errorMessage;
        })
        .finally(() => {
            store.dispatch(endFetching(request.url));
        });
}

//Process reuqest ny request type.
async function processRequestByRequestType(request) {
    if (request.requestType === requestTypes.POST_REQUEST) {
        //return await axiosProvider.post(request.url, request.body);
        executePost();
    }
}

//Check that action needs authentication token.
function isActionNeedAuthorizationToken(request) {
    return request.authorized && request.authorized === true;
}

export default api;
